module.exports = __webpack_public_path__ + "img/tasas.8e8f2d34.jpeg";